import script from "./VDSCertificate.vue?vue&type=script&setup=true&lang=js"
export * from "./VDSCertificate.vue?vue&type=script&setup=true&lang=js"

import "./VDSCertificate.vue?vue&type=style&index=0&id=3bcdbe56&lang=css"

const __exports__ = script;

export default __exports__